<template>
  <div class="ts-space-y-2">
    <div class="row">
      <div class="col-md-12">
        <label class="ts-text-xs">{{ $t('warehourse.nameKh') }}</label>
        <input
          v-model="model.location_name_kh"
          type="text"
          class="form-control"
          :class="{ 'is-invalid': errors.has('location_name_kh') }"
        />
        <div
          class="invalid-feedback ts-text-xs"
          v-if="errors.has('location_name_kh')"
        >
          {{ errors.first('location_name_kh') }}
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <label class="required ts-text-xs">{{ $t('warehourse.nameEn') }}</label>
        <input
          v-model="model.location_name_en"
          type="text"
          class="form-control"
          :class="{ 'is-invalid': errors.has('location_name_en') }"
        />
        <div
          class="invalid-feedback ts-text-xs"
          v-if="errors.has('location_name_en')"
        >
          {{ errors.first('location_name_en') }}
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <label class="required">{{ $t('warehourse.saleType') }}</label>
        <a-select
          style="width: 100%; font-size: 15px"
          allowClear
          v-model="model.sale_type"
          :options="posType"
          placeholder="All"
        ></a-select>
        <div class="validate" v-if="errors.has('sale_type')">
          {{ errors.first('sale_type') }}
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <label class="required">{{ $t('warehourse.companyName') }}</label>
        <a-select
          style="width: 100%; font-size: 15px"
          v-model="model.company_name"
          :options="companyType"
          placeholder="All"
        ></a-select>
        <div class="validate" v-if="errors.has('company_name')">
          {{ errors.first('company_name') }}
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <ts-checkbox v-model="model.is_main_warehouse">{{
          $t('warehourse.isMain')
        }}</ts-checkbox>
        <ts-checkbox v-model="model.is_transfer_approval_one_time">{{
          $t('warehourse.isTransferApprovalOneTime')
        }}</ts-checkbox>
        <div class="validate ts-text-xs" v-if="errors.has('is_main_warehouse')">
          {{ errors.first('is_main_warehouse') }}
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <label class="ts-text-xs">{{ $t('warehourse.productWarranty') }}</label>
        <input
          v-model.number="model.product_warranty_day"
          type="number"
          class="form-control"
          :class="{ 'is-invalid': errors.has('product_warranty_day') }"
        />
        <div
          class="invalid-feedback ts-text-xs"
          v-if="errors.has('product_warranty_day')"
        >
          {{ errors.first('product_warranty_day') }}
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 ts-mt-3 text-right">
        <ts-button class="mr-2" @click.prevent="() => $emit('cancel')">
          {{ $t('cancel') }}
        </ts-button>
        <ts-button
          v-if="!isUpdate"
          color="primary"
          @click.prevent="onSave"
          :waiting="waiting"
          >{{ $t('save') }}</ts-button
        >
        <ts-button
          v-if="isUpdate"
          color="primary"
          @click.prevent="onUpdate"
          :waiting="waiting"
          >{{ $t('update') }}</ts-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapState } from 'vuex'

export default {
  name: 'warehourseForm',
  data () {
    return {
      errors: new Errors(),
      waiting: false,
      waiting_new: false,
      model: {
        location_id: 0,
        location_name_kh: null,
        location_name_en: null,
        is_main_warehouse: false,
        product_warranty_day: null,
        sale_type: null,
        is_transfer_approval_one_time: false,
        company_name: 'meta'
      }
    }
  },
  created () {
    this.setEditData()
  },
  computed: {
    ...mapState('stock/warehourse', ['edit_data']),
    isUpdate () {
      return !_.isEmpty(this.edit_data)
    },
    posType () {
      return [
        { value: 'Retail', label: 'Digital Price (Retail Sale)' },
        { value: 'Wholesale', label: 'Dealer Price (Wholesale)' }
      ]
    },
    companyType () {
      return [
        { value: 'meta', label: 'Meta' },
        { value: 'gm88', label: 'GM88' }
      ]
    }
  },
  methods: {
    onSave () {
      this.waiting = true
      this.$store
        .dispatch('stock/warehourse/store', this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.$emit('fetchData')
          this.$emit('cancel')
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    onUpdate () {
      this.waiting = true
      this.$store
        .dispatch('stock/warehourse/update', {
          id: this.model.location_id,
          data: this.model
        })
        .then(response => {
          this.$toasted.success(response.message)
          this.$emit('fetchData')
          this.$emit('cancel')
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    setEditData () {
      if (!_.isEmpty(this.edit_data)) {
        this.model.location_id = this.edit_data.location_id
        this.model.location_name_kh = this.edit_data.location_name_kh
        this.model.location_name_en = this.edit_data.location_name_en
        this.model.sale_type = this.edit_data.sale_type
        this.model.is_main_warehouse = this.edit_data.is_main_warehouse
        this.model.product_warranty_day = this.edit_data.product_warranty_day
        this.model.is_transfer_approval_one_time =
          this.edit_data.is_transfer_approval_one_time
        this.model.company_name = this.edit_data.company_name
      }
    }
  }
}
</script>
